import React, { useState, useEffect } from 'react';
import EyeSvg from './eye.svg';
import TextSvg from './text.svg';
import './eye.css';

interface EyeProps {
  className?: string;
}

const Eye: React.FC<EyeProps> = ({ className = '' }) => {
  const [rotation, setRotation] = useState(0);
  const [isWatching, setIsWatching] = useState(false);

  useEffect(() => {
    const handleFocus = (event: FocusEvent) => {
      const target = event.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        setIsWatching(true);
        setRotation(120);
      }
    };

    const handleBlur = () => {
      setIsWatching(false);
      setRotation(0);
    };

    const handleInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
        const value = target.value;
        
        
        const baseRotation = 120; 
        const rotationPerChar = 5; 
        const calculatedRotation = baseRotation - (value.length * rotationPerChar);
        const limitedRotation = Math.max(40, calculatedRotation); 
        setRotation(limitedRotation);
      }
    };

    document.addEventListener('focusin', handleFocus);
    document.addEventListener('focusout', handleBlur);
    document.addEventListener('input', handleInput);

    return () => {
      document.removeEventListener('focusin', handleFocus);
      document.removeEventListener('focusout', handleBlur);
      document.removeEventListener('input', handleInput);
    };
  }, []);

  return (
    <div className={`eye-container ${className}`}>
      <img 
        src={EyeSvg} 
        alt="Глаз" 
        className={`eye-logo ${isWatching ? 'eye-watching' : ''}`}
        style={{
          transform: `rotate(${rotation}deg)`,
          transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        }}
      />
      <img 
        src={TextSvg} 
        alt="Текст" 
        className="text-logo"
      />
    </div>
  );
};

export default Eye;
